module.exports = __webpack_public_path__ + "media/images/lp_v6_step05-4836816f963e988a91df18cf280ca1b2.webp";